import configs from '@/plugins/configs.js';
import User from '@/entities/User.js';

const authUser = configs.inIframe ? null : JSON.parse(localStorage.getItem('authUser'));

export default {
    authUser: new User(authUser),
    pageTitle: 'NioText',
    templatePlaceholders: [],
    partners: [],
    segmentsUsage: 0,
};
